<div>
    <div>
        <div>
            <mat-card-title>Kurs: {{ data.course }}</mat-card-title>
        </div>
        <mat-card-subtitle class="insideText">Zeit: {{ data.starttime }} - {{ data.endtime }}</mat-card-subtitle>
        <mat-card-subtitle>Lehrer: {{ data.teacher }}</mat-card-subtitle>
        <mat-card-subtitle *ngIf="data.date !== undefined">Datum: {{ data.date }}</mat-card-subtitle>
        <div *ngIf="data.user === 'felipe@alliancegermany.com' || data.user === 'kilianduetsch@yahoo.de' || data.user === 'philip.eger@gmx.de' || data.user === 'jasmindahl91@gmail.com' || data.user === 'wallat.bjoern@web.de' || data.user === 'wolfgang.distler@gmx.de'">
          <mat-card-subtitle
            *ngIf="data.likers.length !== data.capacity"
            [ngStyle]="{'color': 'green' }"
          >
            Kursbelegung: {{ data.likers.length }}
          </mat-card-subtitle>
        </div>
        <div *ngIf="data.user === 'felipe@alliancegermany.com' || data.user === 'kilianduetsch@yahoo.de' || data.user === 'philip.eger@gmx.de' || data.user === 'jasmindahl91@gmail.com' || data.user === 'wallat.bjoern@web.de' || data.user === 'wolfgang.distler@gmx.de'">
          <mat-card-subtitle>Signed-in users:</mat-card-subtitle>
            <div *ngFor="let liker of data.likers">
              <div> - {{ liker }} </div>
            </div>
        </div>
    </div>
    <div class="center">
        <div>
            <div *ngIf="(this.arrayToUse.includes(data.day))">
              <button
                mat-stroked-button
                *ngIf="((data.likers.length < data.capacity) || (data.likers.length >= data.capacity && data.likers.includes(data.user) === true)) && data.user !== 'felipe@alliancegermany.com' && onDateValid(data.date)"
                type="submit"
                (click)="onRegisterClick(data)"
                class="btn btn-default button"
                [ngStyle]="{'background': data.likers.includes(data.user) ? 'gray' : '#2abe94' }"
              >{{ data.likers.includes(data.user) === true ? 'Von Kurs abmelden' : 'Für Kurs anmelden' }}</button>
            </div>

          <div>
            <button mat-stroked-button type="submit" (click)="onNoClick()" class="btn btn-default button">Schließen</button>
          </div>
        </div>
    </div>
</div>
